import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import DataTable from "react-data-table-component";
import "../../../libs/css/dataTable.css";
import FilterComponent from "./FilterComponent";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const UnSubscriptionTable = forwardRef((props, ref) => {
  const {
    capitalizeWords,
    isLoading,
    setIsLoading,
    columns,
    dataTotal,
    dataList,
    countPerPage,
    setPage,
    isFade,
    handleDuration,
    handleOthers,
    registerName,
    clearInputs,
    isAuthExpired,
    cpSelected,
    allCPs,
    isLoading1,
    userSessions,
    networkData,
  } = props;

  const filterRef = useRef(null);
  const [games, setGames] = useState("");

  // Expose resetFilter method to parent via ref
  useImperativeHandle(ref, () => ({
    resetFilter: () => {
      if (filterRef.current) {
        filterRef.current.resetForm();
      }
    },
  }));

  // Calculate total count
  const totalCount = dataList.reduce((sum, item) => sum + (item.count || 0), 0);

  // Add total row to data
  const dataWithTotal = [
    ...dataList,
    {
      bearerId: "TOTAL",
      count: totalCount,
      isTotal: true,
    },
  ];

  return (
    <div className="App">
      <>
        <FilterComponent
          ref={filterRef}
          handleDuration={handleDuration}
          handleOthers={handleOthers}
          registerName={registerName}
          clearInputs={clearInputs}
          allCPs={allCPs}
          setGames={setGames}
          userSessions={userSessions}
          networkData={networkData}
        />

        <div style={{ opacity: isFade ? "0.3" : 1 }}>
          <div className="text-left pl-5 mt-15 mb-5 text-black d-flex gap-4">
            <span>Default CP: {cpSelected || "All"}</span>{" "}
            {games && <span>Selected Service: {games || ""}</span>}
          </div>

          <DataTable
            className="unsub_datatable users"
            title=""
            columns={columns}
            data={dataWithTotal}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={dataTotal}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page)}
            conditionalRowStyles={[
              {
                when: (row) => row.isTotal,
                style: {
                  backgroundColor: "#f0f0f0",
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderTop: "2px solid #069",
                },
              },
            ]}
          />

          {dataTotal <= 0 && (
            <div className="mt-20">
              Please filter on the filter boxes above to populate data
            </div>
          )}
        </div>
      </>
    </div>
  );
});

export default UnSubscriptionTable;
